export default __webpack_public_path__ + "static/media/noexpl_012_EN.04b65409.png";